// extracted by mini-css-extract-plugin
export default {"mobile":"767px","tablet":"1023px","smallDesktop":"1535px","smallMobileWidth":"549px"};
    if(module.hot) {
      // 1717073175028
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  